import {
  Button,
  Col,
  DatePicker,
  Modal,
  Row,
  Select,
  Space,
  Empty,
} from "antd";
import React, { Component } from "react";
import withRouter from "../withRouter";
import Cookies from "js-cookie";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import TemperatureDashboardStore from "../store/TemperatureDashboardStore";
import { decode as base64_decode } from "base-64";
import dayjs from "dayjs";
import CompanyAutocomplete from "./CompanyAutocomplete";
import {
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import {
  RightCircleOutlined,
  DownOutlined,
  UpOutlined,
  ReloadOutlined,
  EnvironmentFilled,
  LikeFilled,
  WarningFilled,
  InfoCircleFilled,
} from "@ant-design/icons";
class GatewayDashboard extends Component {
  constructor(props, context) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.temperatureDashboardStore = new TemperatureDashboardStore(this);

    this.state = {
      activeSensorCount: 0,
      offset: 0,
      limit: 50,
      update: 0,
      showSensorTable: false,
      type: 0,
      loadData: 0,
      vehiclesArray: [],
      vehicleId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:00"),
      showGatewaySensors: false,
      gatewayList: [],
      selectedGateways:JSON.parse(base64_decode(Cookies.get("data"))).isadmin == 1 ? [-1] : [],
      sensorsList: [],
      selectedSensors: [],
      sensorDetails: [],
      showSensorGraph: false,
      sensorFromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      sensorToDate: dayjs().format("YYYY-MM-DD 23:59:00"),
      sensorId: -1,
      sensorVehicleId: -1,
      sensorGraphArray: [],
      sensorVehicleNo: "",

      // Redesign additions
      collapsedGateways: {},
      lastUpdatedTime: new Date(),
      lastUpdatedText: "Just now",
    };
  }

  async componentDidMount() {
    if (JSON.parse(base64_decode(Cookies.get("data"))).isadmin == 1) {
      await this.setState({
        companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
      });
      await this.getServiceData(this.state.companyId);
      const sensorDetails =
        await this.temperatureDashboardStore.loadSensorDetailsByIds(
          this.state.companyId,
          this.state.selectedGateways
        );
      this.setState({ sensorDetails });

      const sensors =
        await this.temperatureDashboardStore.loadSensorsByGateways(
          this.state.companyId,
          this.state.selectedGateways
        );

      console.log(sensors);

      this.setState({ sensorsList: sensors });
    }
    await this.setState({ update: 1 });

    this.updateLastUpdatedText();
    this.lastUpdatedInterval = setInterval(() => {
      this.updateLastUpdatedText();
    }, 60000);
  }

  componentWillUnmount() {
    if (this.lastUpdatedInterval) {
      clearInterval(this.lastUpdatedInterval);
    }
  }

  updateLastUpdatedText = () => {
    if (!this.state.lastUpdatedTime) return;
    const diffMs = new Date() - this.state.lastUpdatedTime;
    const diffMins = Math.floor(diffMs / 60000);
    let text = "Just now";
    if (diffMins > 0) {
      text = `${diffMins} min${diffMins > 1 ? "s" : ""} ago`;
    }
    this.setState({ lastUpdatedText: text });
  };

  handleRefresh = async () => {
    this.setState({ lastUpdatedTime: new Date(), lastUpdatedText: "Just now" });
    await this.getServiceData(this.state.companyId);
    if (this.state.selectedGateways && this.state.selectedGateways.length > 0) {
      const sensorDetails =
        await this.temperatureDashboardStore.loadSensorDetailsByIds(
          this.state.companyId,
          this.state.selectedGateways
        );
      this.setState({ sensorDetails });
      const sensors =
        await this.temperatureDashboardStore.loadSensorsByGateways(
          this.state.companyId,
          this.state.selectedGateways
        );
      this.setState({ sensorsList: sensors });
    }
  };

  toggleGatewayCollapse = (index) => {
    this.setState((prevState) => ({
      collapsedGateways: {
        ...prevState.collapsedGateways,
        [index]: !prevState.collapsedGateways[index],
      },
    }));
  };

  getSummaryStats = () => {
    let totalSensors = 0;
    let normal = 0;
    let warning = 0;
    let critical = 0;

    const sensorDetails = this.state.sensorDetails || [];
    sensorDetails.forEach((gateway) => {
      if (gateway.sensors) {
        gateway.sensors.forEach((sensor) => {
          totalSensors++;
          const status = (sensor.status || "normal").toLowerCase();
          if (status === "critical" || status === "faulty") {
            critical++;
          } else if (status === "warning") {
            warning++;
          } else {
            normal++;
          }
        });
      }
    });

    return { totalSensors, normal, warning, critical };
  };

  showSensorsGraph = async () => {
    const sensorGraphArray =
      await this.temperatureDashboardStore.loadSensorGraphData({
        companyId: this.state.companyId,
        vehicleId: this.state.sensorVehicleId,
        fromDate: this.state.sensorFromDate,
        toDate: this.state.sensorToDate,
        sensorId: this.state.sensorId,
      });

    this.setState({ sensorGraphArray: sensorGraphArray });
    await this.setState({ update: 1 });
  };

  async handleChange(comp) {
    const isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin == 1;
    const defaultGateways = isadmin ? [-1] : [];

    await this.setState({
      companyId: comp?.value,
      selectedGateways: defaultGateways,
      selectedSensors: [],
      sensorDetails: [],
      sensorsList: []
    });

    await this.getServiceData(comp?.value);

    // if (comp?.value) {
    //   const sensorDetails =
    //     await this.temperatureDashboardStore.loadSensorDetailsByIds(
    //       comp.value,
    //       defaultGateways
    //     );
    //   this.setState({ sensorDetails });

    //   const sensors =
    //     await this.temperatureDashboardStore.loadSensorsByGateways(
    //       comp.value,
    //       defaultGateways
    //     );
    //   this.setState({ sensorsList: sensors });
    // }
  }
  getServiceData = async (companyId) => {
    await this.temperatureDashboardStore.loadSensorTableData({
      companyId: companyId,
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      isSensorTab: this.state.isSensorTab,
    });

    const gateways = await this.temperatureDashboardStore.loadGateways({
      companyId: companyId,
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
    });
    this.setState({ gatewayList: gateways });
    await this.setState({
      activeSensorCount:
        this.temperatureDashboardStore?.sensorDataArray?.length,
    });
  };
  render() {
    const { totalSensors, normal, warning, critical } = this.getSummaryStats();

    // Percentages for indicators
    const normalPct = totalSensors > 0 ? Math.round((normal / totalSensors) * 100) : 100;
    const warningPct = totalSensors > 0 ? Math.round((warning / totalSensors) * 100) : 0;
    const criticalPct = totalSensors > 0 ? Math.round((critical / totalSensors) * 100) : 0;

    return (
      <div
        style={{
          // background: "#f4f7fc",
          background:"#ecefef",
          minHeight: "100vh",
          padding: "15px 6px",
          fontFamily: "'Public Sans', 'Inter', sans-serif"
        }}
      >
        {/* Top Filters & Refresher Bar */}
        <div
          style={{
              position: "sticky",
              top: 15,
              zIndex: 1000,
              // background: "#fff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "16px",
              marginBottom: "24px",
              padding: "10px 0",
            }}
          >
        
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <CompanyAutocomplete
              className="searchInput"
              onChange={this.handleChange}
              allowClear={true}
              style={{ width: 200, borderRadius: "8px" }}
              status={this.state.Notcompany ? "error" : false}
            />
            <Select
              className="searchInput"
              // mode="multiple"
              maxTagCount="responsive"
              style={{ width: 220 }}
              value={this.state.selectedGateways}
              placeholder={this.context.translate("_VEHICLE_NO_") || "Vehicle Number"}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              onChange={async (selectedGateways) => {
                this.setState({ selectedGateways });
                if (!selectedGateways || selectedGateways.length === 0) {
                  this.setState({ sensorDetails: [] }); // clear existing data if any
                  return;
                }
                const CompanyId = this.state.companyId;
                const sensorDetails =
                  await this.temperatureDashboardStore.loadSensorDetailsByIds(
                    CompanyId,
                    selectedGateways
                  );
                this.setState({ sensorDetails });
                const sensors =
                  await this.temperatureDashboardStore.loadSensorsByGateways(
                    CompanyId,
                    selectedGateways
                  );
                this.setState({ sensorsList: sensors });
              }}
            >
              {this.state.gatewayList.map((gateway) => (
                <Select.Option
                  key={gateway.deviceId}
                  value={gateway.vehicleId}
                >
                  {gateway.vehicleNo}
                </Select.Option>
              ))}
            </Select>
            <Select
              className="searchInput"
              // mode="multiple"
              showSearch
              maxTagCount="responsive"
              style={{ width: 240 }}
              onSelect={async (type) => {
                this.setState({ type: type });
              }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              placeholder={this.context.translate("_VEHICLENO_SENSORS_") || "Sensor"}
              value={this.state.selectedSensors}
              onChange={async (selectedSensors) => {
                this.setState({ selectedSensors });
                const CompanyId = this.state.companyId;
                const selectedSensorDetails = this.state.sensorsList.filter(
                  (sensor) => selectedSensors.includes(sensor.sensorId)
                );
                const vehicleIds = selectedSensorDetails.map(
                  (s) => s.vehicleId
                );
                const uniqueVehicleIds = [...new Set(vehicleIds)];
                console.log(
                  "Selected Sensor-Vehicle Pairs:",
                  uniqueVehicleIds
                );
                const sensorDetails =
                  await this.temperatureDashboardStore.loadSensorDetailsByIds(
                    CompanyId,
                    this.state.selectedGateways,
                    selectedSensors
                  );
                this.setState({ sensorDetails });
              }}
            >
              {this.state.sensorsList.map((sensor, index) => (
                <Select.Option value={sensor.sensorId} key={index}>
                  {sensor.sensor}
                </Select.Option>
              ))}
            </Select>
          </div>

          {/* <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "13px", color: "#64748b", fontWeight: "500" }}>
              Last updated: {this.state.lastUpdatedText}
            </span>
            <Button
              type="text"
              icon={<ReloadOutlined style={{ fontSize: "16px", color: "#334155" }} />}
              onClick={this.handleRefresh}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                width: "36px",
                height: "36px",
                background: "#ffffff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              }}
            />
          </div> */}
        </div>

        {/* Four Gorgeous KPI Cards */}
        {/* <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "20px",
            marginBottom: "30px",
          }}
        > */}
          {/* Card 1: Sensor Battery */}
          {/* <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              padding: "20px 24px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.03)",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              border: "1px solid #eef2f6",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "14px",
                background: "hsla(217, 100%, 95%, 1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <EnvironmentFilled style={{ fontSize: "24px", color: "hsla(217, 100%, 60%, 1)" }} />
            </div>
            <div>
              <div style={{ fontSize: "13px", color: "#64748b", fontWeight: "600", marginBottom: "4px" }}>
                Sensor Battery
              </div>
              <div style={{ fontSize: "28px", color: "#1e293b", fontWeight: "800", lineHeight: "1.1" }}>
                {totalSensors}
              </div>
              <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "4px", fontWeight: "500" }}>
                All monitored locations
              </div>
            </div>
          </div> */}

          {/* Card 2: Normal */}
          {/* <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              padding: "20px 24px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.03)",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              border: "1px solid #eef2f6",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "14px",
                background: "hsla(145, 80%, 95%, 1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LikeFilled style={{ fontSize: "24px", color: "hsla(145, 80%, 40%, 1)" }} />
            </div>
            <div>
              <div style={{ fontSize: "13px", color: "hsla(145, 80%, 35%, 1)", fontWeight: "600", marginBottom: "4px" }}>
                Normal
              </div>
              <div style={{ fontSize: "28px", color: "#1e293b", fontWeight: "800", lineHeight: "1.1" }}>
                {normal}
              </div>
              <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "4px", fontWeight: "500" }}>
                {normalPct}% within range
              </div>
            </div>
          </div> */}

          {/* Card 3: Warning */}
          {/* <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              padding: "20px 24px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.03)",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              border: "1px solid #eef2f6",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "14px",
                background: "hsla(38, 100%, 95%, 1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WarningFilled style={{ fontSize: "24px", color: "hsla(38, 100%, 50%, 1)" }} />
            </div>
            <div>
              <div style={{ fontSize: "13px", color: "hsla(38, 100%, 40%, 1)", fontWeight: "600", marginBottom: "4px" }}>
                Warning
              </div>
              <div style={{ fontSize: "28px", color: "#1e293b", fontWeight: "800", lineHeight: "1.1" }}>
                {warning}
              </div>
              <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "4px", fontWeight: "500" }}>
                {warningPct}% require attention
              </div>
            </div>
          </div> */}

          {/* Card 4: Critical */}
          {/* <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              padding: "20px 24px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.03)",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              border: "1px solid #eef2f6",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "14px",
                background: "hsla(350, 100%, 95%, 1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <InfoCircleFilled style={{ fontSize: "24px", color: "hsla(350, 100%, 55%, 1)" }} />
            </div>
            <div>
              <div style={{ fontSize: "13px", color: "hsla(350, 100%, 45%, 1)", fontWeight: "600", marginBottom: "4px" }}>
                Critical
              </div>
              <div style={{ fontSize: "28px", color: "#1e293b", fontWeight: "800", lineHeight: "1.1" }}>
                {critical}
              </div>
              <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "4px", fontWeight: "500" }}>
                {criticalPct}% critical issues
              </div>
            </div>
          </div>
        </div> */}

        {/* Collapsible Gateway Rows */}
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {this.state.sensorDetails.length > 0 ? (
            this.state.sensorDetails.map((gateway, index) => {
              const isCollapsed = !!this.state.collapsedGateways[index];

              // Calculate status of this gateway. If any sensors are critical/warning, gateway state changes
              let gatewayStatus = "All Normal";
              if (gateway.sensors) {
                const hasIssues = gateway.sensors.some(s => {
                  const sStatus = (s.status || "normal").toLowerCase();
                  return sStatus === "critical" || sStatus === "faulty" || sStatus === "warning";
                });
                if (hasIssues) {
                  gatewayStatus = "Attention Required";
                }
              }

              return (
                <div
                  key={index}
                  style={{
                    background: "#ffffff",
                    borderRadius: "16px",
                    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.03)",
                    border: "1px solid #eef2f6",
                    overflow: "hidden",
                  }}
                >
                  {/* Gateway Header Panel */}
                  <div
                    onClick={() => this.toggleGatewayCollapse(index)}
                    style={{
                      padding: "18px 24px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                      userSelect: "none",
                      background: "#ffffff",
                      
                      borderBottom: isCollapsed ? "none" : "1px solid #f1f5f9",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
                      <span style={{ fontSize: "15px", color: "#1e293b", fontWeight: "700" }}>
                        Gateway: <span style={{ color: "#2563eb" }}>{gateway.gatewayName}</span>
                      </span>

                      <div style={{ width: "1px", height: "16px", background: "#e2e8f0", margin: "0 12px" }} />

                      <span style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>
                        Vehicle No: <span style={{ color: "#334155", fontWeight: "700" }}>{gateway.vehicleNo || "N/A"}</span>
                      </span>

                      <div style={{ width: "1px", height: "16px", background: "#e2e8f0", margin: "0 12px" }} />

                      <span style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>
                        Battery Voltage: <span style={{ color: "#334155", fontWeight: "700" }}>{gateway.batteryVoltage || "0"}</span>
                      </span>

                      <div style={{ width: "1px", height: "16px", background: "#e2e8f0", margin: "0 12px" }} />

                      <span style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>
                        Power Voltage: <span style={{ color: "#334155", fontWeight: "700" }}>{gateway.powerVoltage || "0"}</span>
                      </span>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                      {/* <span
                        style={{
                          padding: "4px 12px",
                          borderRadius: "20px",
                          fontSize: "11px",
                          fontWeight: "700",
                          background: gatewayStatus === "All Normal" ? "hsla(145, 80%, 95%, 1)" : "hsla(38, 100%, 95%, 1)",
                          color: gatewayStatus === "All Normal" ? "hsla(145, 80%, 30%, 1)" : "hsla(38, 100%, 40%, 1)",
                        }}
                      >
                        {gatewayStatus}
                      </span> */}
                      {isCollapsed ? (
                        <DownOutlined style={{ fontSize: "13px", color: "#64748b" }} />
                      ) : (
                        <UpOutlined style={{ fontSize: "13px", color: "#64748b" }} />
                      )}
                    </div>
                  </div>

                  {/* Gateway Sensors Grid (Body) */}
                  {!isCollapsed && (
                    <div
                      style={{
                        padding: "24px",
                        // background: "#fafbfd",
                         background: "rgb(212, 221, 221)",
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "20px",
                      }}
                    >
                      {gateway.sensors && gateway.sensors.length > 0 ? (
                        gateway.sensors.map((sensor) => {
                          const sensorStatus = (sensor.status || "Normal");
                          const isWarning = sensorStatus.toLowerCase() === "warning";
                          const isCritical = sensorStatus.toLowerCase() === "critical" || sensorStatus.toLowerCase() === "faulty";

                          let dotColor = "#10b981"; // green for normal
                          if (isWarning) dotColor = "#f59e0b"; // orange
                          if (isCritical) dotColor = "#ef4444"; // red

                          return (
                            <div
                              key={sensor.id}
                              style={{
                                background: "#ffffff",
                               
                                borderRadius: "12px",
                                border: "1px solid #f1f5f9",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.01)",
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                transition: "all 0.2s ease",
                              }}
                            >
                              {/* Card Top: Sensor ID & Status */}
                              <div
                                style={{
                                  padding: "14px 18px",
                                  borderBottom: "1px solid #f2f8fb",
                                  // background:"#ecefef",
                                  background: "#f4f7fc",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <span style={{ fontSize: "13px", color: "#475569", fontWeight: "700" }}>
                                  Sensor Id: <span style={{ color: "#0f172a" }}>{sensor.id}</span>
                                </span>
                                {/* <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                  <span
                                    style={{
                                      width: "7px",
                                      height: "7px",
                                      borderRadius: "50%",
                                      background: dotColor,
                                      display: "inline-block",
                                    }}
                                  /> */}
                                  {/* <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "700",
                                      color: dotColor,
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {sensorStatus}
                                  </span> */}
                                {/* </div> */}
                              </div>

                              {/* Card Body: Temperature & Humidity */}
                              <div
                                style={{
                                  padding: "18px 24px",
                                  display: "flex",
                                  // justifyContent: "space-between",
                                  gap: "130px",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  <div style={{ fontSize: "12px", color: "#94a3b8", fontWeight: "600", marginBottom: "4px" }}>
                                    Temperature
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "26px",
                                      fontWeight: "800",
                                      color: "#0066ff",
                                      display: "flex",
                                      alignItems: "baseline",
                                      gap: "4px",
                                    }}
                                  >
                                    {sensor.temp}
                                    <span style={{ fontSize: "16px", fontWeight: "700", color: "#3b82f6" }}>°c</span>
                                  </div>
                                </div>

                                <div style={{ textAlign: "right" }}>
                                  <div style={{ fontSize: "12px", color: "#94a3b8", fontWeight: "600", marginBottom: "4px" }}>
                                    Humidity
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "26px",
                                      fontWeight: "800",
                                      color: "#7c3aed",
                                      display: "flex",
                                      alignItems: "baseline",
                                      gap: "4px",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    {sensor.humidity}
                                    <span style={{ fontSize: "16px", fontWeight: "700", color: "#8b5cf6" }}>%</span>
                                  </div>
                                </div>
                              </div>

                              {/* Divider */}
                              <div style={{ height: "1px", background: "#f8fafc", margin: "0 18px" }} />

                              {/* Card Bottom: Battery, RSSI, Time, Arrow */}
                              <div
                                style={{
                                  padding: "14px 18px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                  <div style={{ fontSize: "10px", color: "#94a3b8", fontWeight: "600" }}>
                                    Sensor Battery
                                  </div>
                                  <div style={{ fontSize: "12px", color: "#334155", fontWeight: "700" }}>
                                    {sensor.battery || "N/A"}
                                  </div>
                                </div>

                                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                  <div style={{ fontSize: "10px", color: "#94a3b8", fontWeight: "600" }}>
                                    RSSI ID
                                  </div>
                                  <div style={{ fontSize: "12px", color: "#334155", fontWeight: "700" }}>
                                    {sensor.rssi || "N/A"}
                                  </div>
                                </div>

                                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                  <div style={{ fontSize: "10px", color: "#94a3b8", fontWeight: "600" }}>
                                    Sensor Time
                                  </div>
                                  <div style={{ fontSize: "12px", color: "#334155", fontWeight: "700" }}>
                                    {sensor.timestamp || "N/A"}
                                  </div>
                                </div>

                                <Button
                                  type="text"
                                  icon={<RightCircleOutlined style={{ fontSize: "20px", color: "#3b82f6" }} />}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 0,
                                    margin: 0,
                                    height: "auto",
                                    background: "transparent",
                                  }}
                                  onClick={async () => {
                                    const currentDate = dayjs();
                                    await this.setState({
                                      sensorFromDate: currentDate
                                        .startOf("day")
                                        .format("YYYY-MM-DD"),
                                      sensorToDate: currentDate
                                        .endOf("day")
                                        .format("YYYY-MM-DD"),
                                      showSensorGraph: true,
                                      sensorId: sensor.id,
                                      sensorVehicleId: gateway.vehicleId,
                                      sensorVehicleNo: gateway.vehicleNo,
                                    });
                                    await this.showSensorsGraph();
                                  }}
                                />
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div style={{ gridColumn: "1 / -1", textAlign: "center", padding: "40px" }}>
                          <Empty description="No sensors found for this gateway" />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div
              style={{
                textAlign: "center",
                background: "#ffffff",
                borderRadius: "16px",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.03)",
                border: "1px solid #eef2f6",
                color: "#888",
                padding: "60px 20px",
                fontSize: "15px",
                height: "60vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Empty description="Please select a vehicle/sensor to view telemetry" />
            </div>
          )}
        </div>

        {/* Modal structure */}
        <Modal
          title={
            <div className="modal-topbar">
              {/* Left side title + info */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <h1 style={{ margin: 0 }}>
                  {this.context.translate("_SENSOR_GRAPH_") || "Sensor Graph"}
                </h1>

                {/* VehicleNo and Sensor ID beside title */}
                <div
                  style={{
                    fontSize: "14px",
                    color: "#FFFFFF",
                    fontWeight: "600",
                  }}
                >
                  {this.state.sensorVehicleNo && (
                    <>{this.state.sensorVehicleNo}</>
                  )}
                  {this.state.sensorId && (
                    <>
                      &nbsp;|&nbsp;
                      {this.state.sensorId}
                    </>
                  )}
                </div>
              </div>
              <div className="right-align">
                {" "}
                <Button
                  type="primary"
                  onClick={async (pagination) => {
                    this.showSensorsGraph();
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <i
                  className="modal-close las la-times"
                  onClick={() => {
                    this.setState({ showSensorGraph: false });
                  }}
                ></i>
              </div>
            </div>
          }
          className="black-modal-window"
          open={this.state.showSensorGraph}
          footer={null}
          centered
          width="85%"
          onCancel={() => {
            this.setState({ showSensorGraph: false });
          }}
          bodyStyle={{ maxHeight: "67vh", overflowY: "auto" }}
        >
          <div className="temp-report-container sensor-graph-modal">
            <div className="form-row">
              <DatePicker
                className="sensors-field"
                value={
                  this.state.sensorFromDate
                    ? dayjs(this.state.sensorFromDate)
                    : dayjs()
                }
                format="MM-DD-YYYY"
                getPopupContainer={() =>
                  document.querySelector(".sensor-graph-modal")
                }
                onChange={(date) => {
                  if (date === null) {
                    this.setState({ sensorFromDate: "" });
                  } else {
                    const format = "YYYY-MM-DD 00:00:00";
                    this.setState({ sensorFromDate: date.format(format) });
                  }
                }}
              />
              <DatePicker
                className="sensors-field"
                value={
                  this.state.sensorToDate
                    ? dayjs(this.state.sensorToDate)
                    : dayjs()
                }
                format="MM-DD-YYYY"
                disabledDate={(current) => {
                  return current && current > dayjs();
                }}
                getPopupContainer={() =>
                  document.querySelector(".sensor-graph-modal")
                }
                onChange={(date) => {
                  if (date === null) {
                    this.setState({ sensorToDate: "" });
                  } else {
                    const format = "YYYY-MM-DD 23:59:00";
                    this.setState({ sensorToDate: date.format(format) });
                  }
                }}
              />
            </div>
            <div style={{ marginBottom: "50px" }}>
              <ResponsiveContainer height={420}>
                {this.state.sensorGraphArray &&
                  this.state.sensorGraphArray.length > 0 ? (
                  <LineChart
                    width={500}
                    data={this.state.sensorGraphArray}
                    margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
                  >
                    <XAxis
                      dataKey="timestamp"
                      type="category"
                      angle={-90}
                      textAnchor="end"
                      label={{ value: "Time", position: "bottom", offset: 50 }}
                      height={120}
                    />
                    <YAxis
                      label={{
                        value: "Temperature /Humidity",
                        angle: -90,
                        position: "insideLeft",
                        offset: 0,
                        dy: 10, // pushes the label downward toward center
                        style: { textAnchor: "middle" },
                      }}
                    />
                    <Tooltip />
                    <Legend verticalAlign="top" />
                    <Line
                      type="monotone"
                      dataKey="temperature"
                      stroke="blue"
                      name="Temperature (°C)"
                      dot={true}
                    />
                    <Line
                      type="monotone"
                      dataKey="humidity"
                      stroke="green"
                      name="Humidity (%)"
                      dot={true}
                    />
                  </LineChart>
                ) : (
                  <Empty></Empty>
                )}
              </ResponsiveContainer>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
GatewayDashboard.contextType = StoreContext;
export default observer(withRouter(GatewayDashboard));
